<template>
  <div id="app">
   <router-view />
  </div>
</template>

<script>
export default{
  name: 'App',

  created(){
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
    }
    
  },

  mounted() {
    // 检测浏览器路由改变页面不刷新问题,hash模式的工作原理是hashchange事件

    window.addEventListener('hashchange', () => {

      let currentPath = window.location.hash.slice(1)

      if (this.$route.path !== currentPath) {

        this.$router.push(currentPath)

      }

    }, false),
    // 在页面刷新时将store保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })

}
}
</script>



// WEBPACK FOOTER //
// src/App.vue